import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 12h12","key":"svg-0"}],["path",{"d":"M9 5v14","key":"svg-1"}],["path",{"d":"M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7","key":"svg-2"}]]

const IconCurrencyKip = createReactComponent('outline', 'currency-kip', 'CurrencyKip', __iconNode);

export default IconCurrencyKip;